import { useHistory } from 'react-router-dom';

// Drop-in for vopay's useUpdateQueryParams that works in every host. The
// portals mount a react-router v5 Router; the micro-apps run react-router v7,
// where v5's useLocation() dereferences an unset context and throws — taking
// the route down and firing its errorElement, which read as the contact drawer
// closing itself. v5's useHistory() is a bare useContext, so it just comes back
// undefined there and the params are written straight to the URL instead.
export default function useUpdateHostQueryParams<T extends Record<string, string | null>>() {
  const history = useHistory();

  return function updateQueryParams(newParams: Partial<T>) {
    const searchParams = new URLSearchParams(window.location.search);

    Object.entries(newParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        searchParams.set(key, String(value));
      } else {
        searchParams.delete(key);
      }
    });

    const search = searchParams.toString();

    if (history) {
      history.replace({ search });

      return;
    }

    // No v5 Router. Only the query string changes, so there is no route change
    // to announce — but the current history state is passed back through, since
    // the host's own router keeps its entry bookkeeping there (v7 stores
    // { key, idx }) and dropping it breaks its later navigations.
    const { pathname, hash } = window.location;
    window.history.replaceState(window.history.state, '', `${pathname}${search ? `?${search}` : ''}${hash}`);
  };
}
